module.exports = __webpack_public_path__ + "img/uptimerobot-logo-dark.bc74db0c.svg";